import axios from "axios";

export const wait = (ms = 0) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const file2Id = file => `${file.size}-${file.name}`;
export const id2FileName = id => id.slice(id.indexOf("-") + 1);

export function absDiff(imgArray1, imgArray2) {
  if (imgArray1.length !== imgArray2.length) {
    throw new Error(
      `Different image array size. ${imgArray1.length} !== ${imgArray2.length}`
    );
  }
  const length = imgArray1.length;
  let diff = 0;
  for (let i = 0; i < length; i++) {
    diff += Math.abs(imgArray1[i] - imgArray2[i]);
  }
  return diff;
}

export function overlayBuffer(
  fromBuf,
  fromW,
  fromH,
  toBuf,
  toW,
  toH,
  x,
  y,
  alpha = 1
) {
  const to8Array = new Uint8ClampedArray(toBuf);
  const from8Array = new Uint8ClampedArray(fromBuf);

  let idx = 0;
  for (let i = 0; i < fromH; i++) {
    const startIdx = ((i + y) * toW + x) * 4;
    for (let j = 0; j < fromW * 4; j++) {
      const toVal = to8Array[startIdx + j];
      const fromVal = from8Array[idx++];
      let newVal;
      if ((j + 1) % 4 === 0) {
        newVal = 255;
      } else {
        newVal = (1 - alpha) * toVal + alpha * fromVal;
      }
      to8Array[startIdx + j] = newVal;
    }
  }
}

export async function overlayBufferAsync(
  fromBuf,
  fromW,
  fromH,
  toBuf,
  toW,
  toH,
  x,
  y,
  alpha = 1
) {
  const to8Array = new Uint8ClampedArray(toBuf);
  const from8Array = new Uint8ClampedArray(fromBuf);

  let idx = 0;
  for (let i = 0; i < fromH; i++) {
    await wait();
    const startIdx = ((i + y) * toW + x) * 4;
    for (let j = 0; j < fromW * 4; j++) {
      const toVal = to8Array[startIdx + j];
      const fromVal = from8Array[idx++];
      let newVal;
      if ((j + 1) % 4 === 0) {
        newVal = 255;
      } else {
        newVal = (1 - alpha) * toVal + alpha * fromVal;
      }
      to8Array[startIdx + j] = newVal;
    }
  }
}

export function downloadBase64(base64, filename = "untitled") {
  const a = document.createElement("a");
  a.setAttribute("type", "hidden");
  a.download = filename;
  a.href = base64;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
  }, 100);
}

export function downloadBlob(blob, filename = "untitled") {
  const url = (window.webkitURL || window.URL).createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("type", "hidden");
  a.download = filename;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 100);
}

export async function uploadToGCS(blob, url, onUploadProgress = () => {}) {
  try {
    const response = await axios.put(url, blob, {
      headers: {
        "Content-Type": "image/jpeg"
      },
      timeout: 360000,
      onUploadProgress
    });
    return response;
  } catch (error) {
    throw new Error(`Upload error(gcs): ${error.message}`);
  }
}

// export async function uploadToCloudinary(data, onUploadProgress) {
//   const formData = new FormData();
//   formData.append("file", data);
//   formData.append("upload_preset", "kc1e6z9m");

//   try {
//     const response = await axios.post(
//       process.env.REACT_APP_UPLOAD_URL,
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data"
//         },
//         timeout: 360000,
//         // timeout: 120000,
//         onUploadProgress
//       }
//     );
//     return response.data.public_id;
//   } catch (error) {
//     throw new Error(`Upload error(cloudinary): ${error.message}`);
//   }
// }

// export function raceSuccess(promises) {
//   return Promise.all(
//     // If a request fails, count that as a resolution so it will keep
//     // waiting for other possible successes. If a request succeeds,
//     // treat it as a rejection so Promise.all immediately bails out.
//     promises.map(p =>
//       p.then(val => Promise.reject(val), err => Promise.resolve(err))
//     )
//   ).then(
//     // If '.all' resolved, we've just got an array of errors.
//     errors => Promise.reject(errors),
//     // If '.all' rejected, we've got the result we wanted.
//     val => Promise.resolve(val)
//   );
// }

export const camelToRegular = str =>
  str.replace(/([A-Z])/g, " $1").replace(/^./, function(str) {
    return str.toUpperCase();
  });



// WEBPACK FOOTER //
// ./src/lib/utils.js